import type { NutritionBasis } from './types.js';

/**
 * Suggested labels for the nutrition editor. Not a closed set — users can type anything.
 */
export const COMMON_NUTRITION_LABELS = [
  { label: 'Calories', unit: 'kcal' },
  { label: 'Fat', unit: 'g' },
  { label: 'Saturated Fat', unit: 'g' },
  { label: 'Trans Fat', unit: 'g' },
  { label: 'Cholesterol', unit: 'mg' },
  { label: 'Sodium', unit: 'mg' },
  { label: 'Carbohydrates', unit: 'g' },
  { label: 'Fiber', unit: 'g' },
  { label: 'Sugar', unit: 'g' },
  { label: 'Protein', unit: 'g' },
] as const;

export function defaultUnitForNutritionLabel(label: string): string {
  const needle = label.trim().toLowerCase();
  const match = COMMON_NUTRITION_LABELS.find((item) => item.label.toLowerCase() === needle);
  return match?.unit ?? '';
}

export function nutritionBasisLabel(basis: NutritionBasis): string {
  switch (basis) {
    case 'perServing':
      return 'Per serving';
    case 'perRecipe':
      return 'Per recipe';
    default:
      return 'Unknown';
  }
}
